export default {
  methods: {
    showErrors(data) {
      for (let key in data) {
        if (data[key][0]) {
          let erorrsObject = {}
          erorrsObject[key] = [data[key][0]]
          this.$refs.observer.setErrors(erorrsObject)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/mixins/showErrors.js